import { GatewayDeclarationActivite } from "@conformite/gateway";
import {
  Link,
  TagVariant,
  TagWithIcon,
  Button,
  Card,
} from "@endya-conformite/ui-kit";
import ArrowRight from "@endya-conformite/ui-kit/src/assets/icons/arrow-right.svg?react";
import style from "../list/ControleQuinquennalAdminPage.module.scss";

type DeclarationActiviteAdminCardProps = {
  type: "ias" | "iobsp";
  declarationActivite:
    | GatewayDeclarationActivite.DeclarationActiviteIas
    | GatewayDeclarationActivite.DeclarationActiviteIobsp
    | null;
};

export function DeclarationActiviteAdminCard({
  type,
  declarationActivite,
}: DeclarationActiviteAdminCardProps) {
  const title =
    type === "ias"
      ? "Déclaration d'activité IAS"
      : "Déclaration d'activité IOBSP";

  const hasData = declarationActivite !== null;
  const tagVariant: TagVariant = hasData ? "success" : "info";
  const tagText = hasData ? "Données disponibles" : "Aucune donnée";

  return (
    <Card className={style.itemWrapper}>
      <h4>{title}</h4>
      <p>{hasData ? "Formulaire rempli" : "Pas de données"}</p>
      <TagWithIcon variant={tagVariant}>{tagText}</TagWithIcon>
      {hasData && (
        <Link to={`declaration-activite/${type}`}>
          <Button variant="text" icon={<ArrowRight />} className={style.access}>
            Consulter
          </Button>
        </Link>
      )}
    </Card>
  );
}
